jQuery(document).ready(function ($) {
  $('.home-banner-placeholder').css('display', 'none');
  $('.owl-dots-placeholder').css('display', 'none');
  // Function to change background
  function changeBackground() {
    // Add code to change the background of the add to cart element
    // For example:
    $('.pdp-bnr-btns .product-form__submit').addClass('buy-atc-disable');
    $('.shopify-payment-button__button--unbranded').removeClass('buy-now-atc');
    // Store the state in localStorage
    localStorage.setItem('backgroundChanged', true);
  }

  // Function to check and apply background change
  function checkBackground() {
    // Check if the background change is stored
    const backgroundChanged = localStorage.getItem('backgroundChanged');
    if (backgroundChanged) {
      // Apply the background change
      $('.pdp-bnr-btns .product-form__submit').removeClass('buy-atc-disable');
      $('.shopify-payment-button__button--unbranded').addClass('buy-now-atc');
    }
  }

  // Event listener for the "Buy Now" button
  $(document).on('click touchstart', '.shopify-payment-button__button--unbranded', function () {
    changeBackground();
  });

  // Call checkBackground function when the page loads
  checkBackground();

  $(window).on('pageshow', function (event) {
    checkBackground();
  });

  // For Safari on iOS, use the pageshow event with a different approach
  $(window).on('pagehide', function (event) {
    if (event.originalEvent.persisted) {
      checkBackground();
    }
  });

  $('.product__info-wrapper .yotpo-reviews-star-ratings-widget').append('<a href="/collections/build-your-own-bundle">view products</a>');

  // subscibe form

  const $newsletterInput = $('#contact_form.newsletter-form input[type="email"]');
  if ($newsletterInput.length && $newsletterInput.val() && $newsletterInput.val().length > 0) {
    $('#contact_form.newsletter-form')
      .append(`<h3 class="newsletter-form__message newsletter-form__message--error form__message" tabindex="-1" autofocus="">
                  <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                    <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                    <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                    <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                    <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
                  </path>
                  </svg>
                  You have already subscribed.
                  </h3>`);
    document.querySelector('.newsletter-form__field-wrapper .field').style.display = 'none';
    document.querySelector('.newsletter-consent').style.display = 'none';
  }

  $('#tagDropdown ul li').on('click', function () {
    const selectedTag = $(this).attr('data-value');
    const ar = $('.checkout');
    ar.each((a) => {
      const postTags = ar[a].dataset.tags;
      if (selectedTag == undefined || postTags.includes(selectedTag)) {
        ar[a].parentElement.style.display = 'block';
      } else {
        ar[a].parentElement.style.display = 'none';
      }
    });
  });

  $('#close-strip').click(function () {
    $('.head-strip').hide();
  });

  // const $carousel = $('.home-before-bnr .owl-carousel');
  // $carousel.owlCarousel({
  //   autoWidth: true,
  //   margin: 7,
  //   nav: false,
  //   dots: false,
  //   items: 3,
  //   navText: [
  //     '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
  //     '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
  //   ],
  // });

  $('.home-banner-placeholder').css('display', 'none');
  $('.owl-dots-placeholder').css('display', 'none');


  // Force a redraw
  // $(window).on('load', function () {
  //   $carousel.trigger('refresh.owl.carousel');
  // });

  function removeCloneIds() {
    $('.h-bnr-car .owl-item.cloned .banner-slide').each(function () {
      this.removeAttribute('id');
    });
  }

  $('.h-bnr-car').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    autoWidth: true,
    center: true,
    startPosition: 0,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 1,
        autoWidth: false,
        nav: false,
      },
      768: {
        items: 1,
        autoWidth: true,
        stagePadding: 20,
      },
    },
    onInitialized: function () {
      setTimeout(removeCloneIds, 0);
    },
    onRefreshed: function () {
      setTimeout(removeCloneIds, 0);
    }
  });



  $('.home-prd-car:not(.h-spotlight-cnt, .pdp-cstm-temp-collection-carousel)').owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    dots: false,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 2,
        nav: false,
        dots: true,
        margin: 6,
      },
      768: {
        items: 4,
        margin: 4,
      },
      1200: {
        items: 4,
      },
    },
  });

  $('.pdp-cstm-temp-collection-carousel').owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    dots: false,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
        margin: 6,
      },
      768: {
        items: 4,
        margin: 4,
      },
      1200: {
        items: 4,
      },
    },
  });

  $('.prd-prd-car').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoWidth: true,
    stagePadding: 20,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 2,
        nav: false,
        dots: true,
        autoWidth: false,
      },
      768: {
        items: 4,
        autoWidth: true,
      },
      1200: {
        items: 5,
        margin: 20,
      },
    },
  });

  $('.home-common-btn').css('display', 'block');

  $('.home-prd-car1').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 2,
        nav: false,
        dots: true,
      },
      768: {
        items: 4,
      },
      1200: {
        items: 6,
      },
    },
  });
  $('.h-concern-car').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoWidth: true,
    // stagePadding:20,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 3,
        nav: false,
        dots: true,
        autoWidth: false,
      },
      768: {
        items: 4,
        autoWidth: true,
      },
      1200: {
        items: 5,
        margin: 45,
      },
    },
  });

  $('.home-reviews-car').owlCarousel({
    loop: true,
    margin: 40,
    nav: true,
    dots: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
      },
      768: {
        items: 2,
        nav: false,
      },
      1200: {
        items: 3,
      },
    },
  });

  $('.home-beauty-car').owlCarousel({
    loop: true,
    margin: 7,
    nav: true,
    dots: false,
    // stagePadding:20,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 2,
        nav: false,
        dots: true,
        stagePadding: 20,
      },
      768: {
        items: 2,
      },
      1200: {
        items: 3,
        margin: 20,
      },
    },
  });

  $('.home-page--blogs-carousel').owlCarousel({
    loop: true,
    margin: 7,
    nav: true,
    dots: false,
    // stagePadding:20,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 2,
        nav: false,
        dots: true,
        stagePadding: 20,
      },
      768: {
        items: 2,
      },
      1200: {
        items: 3,
        margin: 20,
      },
    },
  });


  $('.collect-beauty-car').owlCarousel({
    loop: false,
    margin: 7,
    nav: true,
    dots: false,
    // stagePadding:20,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 2,
        nav: false,
        dots: true,
        // stagePadding:20,
      },
      768: {
        items: 2,
      },
      1200: {
        items: 4,
        margin: 20,
      },
    },
  });

  $('.in-the-spotlight').owlCarousel({
    items: 1,
    loop: false,
    autoplay: false,
    nav: true,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    dots: true
  });

  // tab system

  $('.home-pro-tabs li').on('click', function () {
    $('.home-pro-tabs li').removeClass('active');
    $(this).addClass('active');

    $('.home-pro-tabs-cnt > *').removeClass('active');

    $(`#${$(this).attr('data-id')}`).addClass('active');
  });

  $('.home-apart .home-apart-card').on('click', function () {
    $('.home-apart .home-apart-card').not($(this)).removeClass('active');
    // Toggle 'active' class on the clicked card
    $(this).toggleClass('active');

    // Check if the clicked card is now active
    if ($(this).hasClass('active')) {
      // If the clicked card is now active, remove 'active' class from all spans
      $('.home-apart span').removeClass('active');

      // Add 'active' class to the span inside the clicked card
      $(this).find('span').addClass('active');
    } else {
      // If the clicked card is now inactive (clicked twice), remove 'active' class from its span
      $(this).find('span').removeClass('active');
    }
  });

  $('.h-bnr-car.owl-theme .owl-nav .owl-prev').css('left', parseFloat($('.home-products .container').css('margin-left')) + 30);
  $('.h-bnr-car.owl-theme .owl-nav .owl-next').css('right', parseFloat($('.home-products .container').css('margin-right')) + 30);
  $('.home-container').css(
    'margin-left',
    $('.home-products .container').css('margin-left')
  );

  $('.home-banner .container').css(
    'min-width',
    $('.home-ingredients .container').css('width')
  );
  if ($(window).width() > 768) {
    $('.home-pro-tabs-cnt .container').css(
      'margin-left',
      parseFloat($('.home-products .container').css('margin-left')) + 10
    );
  }
  $('.home-pro-tabs-cnt .container').css('opacity', 1);

  // ingredients
  // var endpoint = '/blogs/ingredient/articles.json?tag=' + encodeURIComponent("Curry Leaves");
  // fetch(endpoint)
  //     .then(response => response.json())
  //     .then(data => {
  //         console.log(data.articles);
  //     })
  //     .catch(error => {
  //         console.error('Error fetching blog posts:', error);
  //     });

  if (window.location.pathname.includes('product')) {
    if ($('.main-pdp-sec .container .product__info-wrapper').length > 0) {
      $('.home-prd-car.owl-theme .owl-nav .owl-prev').css(
        'margin-left',
        parseFloat(
          $('.main-pdp-sec .container .product__info-wrapper').offset().left
        ) -
        parseFloat($('.main-pdp-sec .container').css('margin-left')) -
        75
      );
    }
    $('.home-container').css(
      'margin-left',
      parseFloat($('.header').css('margin-left'))
    );
  }

  if (window.location.pathname.includes('blogs/ingredient')) {
    $('.home-container').css(
      'margin-left',
      parseFloat($('.header').css('margin-left')) - 20
    );
  }

  if (window.location.pathname.includes('pages/refund-policy')) {
    $('.home-container').css(
      'margin-left',
      parseFloat($('.header').css('margin-left')) - 20
    );
  }
  if (window.location.pathname.includes('blogs/')) {
    $('.navbar #search').on('input', function () {
      $('.row.blogs-row .blog-wrapper').css('display', 'none');
      $('.row.blogs-row .blog-wrapper').each((index, item) => {
        if (
          $('.row.blogs-row .blog-wrapper')
            .eq(index)
            .find('a.title')
            .html()
            .toLowerCase()
            .includes($('.navbar #search').val().toLowerCase())
        ) {
          $('.row.blogs-row .blog-wrapper').eq(index).css('display', 'block');
        }
      });
    });
  }

  if (window.location.pathname.includes('/ingredients')) {
    const $currentTab = $('#allIngredients');
    const card = 4;
    let start = 3;
    $('#ingredientShowMore').on('click', function (e) {
      e.preventDefault();
      $currentTab.children(`:gt(${start}):lt(${card})`).css('display', 'block');
      start += 4;
      if ($currentTab.children().length - 1 <= start) {
        $(this).hide();
      }
      $('#allIngredients').css('max-height', '100%');
    });

    // $currentTab.children(":gt(3)").css("display", "none");

    // if blogs are less than 4 then hide view showMore
    function hideShowMore($target) {
      if ($target.children().length <= 4) {
        $target.parent().find('#ingredientShowMore').hide();
      }
    }
    hideShowMore($currentTab);

    function calculateDistanceFromTop($parent) {
      $parent.parent().find('#ingredientShowMore').click();
      if ($parent.children().length > 4) {
        const distanceFromTop =
          $parent.parent().find('#ingredientShowMore').offset().top -
          $(window).scrollTop();
        // console.log(distanceFromTop);
        if (distanceFromTop <= 1000) {
          $parent.parent().find('#ingredientShowMore').click();
        }
      }
    }

    // Scroll event handler to recalculate distance on scroll
    $(window).on('scroll', function () {
      calculateDistanceFromTop($currentTab);
    });
    calculateDistanceFromTop($currentTab);
    $(window).on('load', function () {
      calculateDistanceFromTop($currentTab);
    });
  }
});

$(document).on(
  'click',
  '.hm-pro-variant .product-form__input--pill > label',
  function (e) {
    if (!$(this).hasClass('active')) {
      $(this).addClass('active').siblings('label').removeClass('active');
      // $(this)
      //   .parent()
      //   .parent()
      //   .parent()
      //   .parent()
      //   .find('.h-pro-price')
      //   .toggleClass('othr-var');
      setTimeout(() => {
        $(this)
          .parent()
          .find(`#${$(this).attr('for')}`)
          .click();
      }, 100);
      setTimeout(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const variantID = urlParams.get('variant');
        // $(this).parent().parent().parent().parent().find('input[name="product-id"]').val(variantID);
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find('input[name="id"]')
          .val(variantID);
      }, 150);

      // to hide quantity
      $(this)
        .parent()
        .parent()
        .parent()
        .parent()
        .find('.custom-qty-wrapper')
        .removeClass('active');
      console.log("removed class")
    }
  }
);

// pdp script
jQuery(document).ready(function ($) {
  const sync1 = $('.pdp-banner-car');
  const sync2 = $('.pdp-thumbnail-car');
  sync1.owlCarousel({
    loop: false,
    margin: 7,
    nav: true,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <path d="M24.375 28.75L15 19.375L24.375 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <path d="M15 10L24.375 19.375L15 28.75" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 1,
        dots: true,
        nav: true,
      },
    },
  });
  sync2.owlCarousel({
    loop: false,
    margin: 7,
    nav: true,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <path d="M24.375 28.75L15 19.375L24.375 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <path d="M15 10L24.375 19.375L15 28.75" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 5,
        dots: true,
      },
    },
    onInitialized: function (e) {
      sync2.find('.owl-item').eq(0).addClass('synced');
    },
  });
  sync2.on('click', '.owl-item', function (e) {
    e.preventDefault();
    const number = $(this).index();
    sync1.eq(1).data('owl.carousel').to(number, 300, true);
  });

  sync1.on('changed.owl.carousel', function (el) {
    const number = el.item.index;
    sync2.find('.owl-item').removeClass('synced').eq(number).addClass('synced');
  });

  // $('.pdp-thumbnail-car .owl-item').on('click', function(e) {
  //   e.stopPropagation()
  //   console.log($(this).index())
  //   var number = $(this).index();
  //    $('.pdp-banner-car').eq(1).data("owl.carousel").to(number, 300, true);
  // })

  $('.pdp-faq-car').owlCarousel({
    loop: true,
    margin: 7,
    nav: true,
    dots: false,
    center: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    ],
    responsive: {
      0: {
        items: 1,
        dots: true,
      },
    },
  });

  $('.pdp-tabs li').on('click', function () {
    $('.pdp-tabs li').removeClass('active');
    $(this).addClass('active');

    if ($(this).index() !== 1) return;

    const $faqBtn = $('#pr-faq > h2 > button');
    if (!$faqBtn.hasClass('collapsed')) return;

    $faqBtn.click();

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    setTimeout(() => {
      let totalOffset = 0;
      if (isMobile) {
        // 👉 Mobile: header usually shrinks, so DO NOT overcalculate
        totalOffset = 120; // stable magic number for mobile
      } else {
        // 👉 Desktop: accurate height calculation
        const headStripHeight = $('.head-strip:visible, .container-fluid.head-strip:visible').outerHeight() || 0;
        const headerHeight = $('header:visible').outerHeight() || 0;
        totalOffset = headStripHeight + headerHeight + 20;
      }
      const targetOffset = $('#pr-faq').offset().top - totalOffset;
      $('html, body').stop().animate({
        scrollTop: targetOffset
      }, 600);

    }, 700);
  });

});

// Tab Accordion
$('.policy-tabs').on('click', '.tab', function (e) {
  e.preventDefault();
  $('.tab').removeClass('active');
  $('.tab-accordion').removeClass('show');
  $(this).addClass('active');
  $($(this).attr('href')).addClass('show');
});

$(document).ready(function () {
  $('#btnToggle').click(function () {
    const passwordInput = $('#CustomerPassword');
    if (passwordInput.attr('type') === 'password') {
      passwordInput.attr('type', 'text');
    } else {
      passwordInput.attr('type', 'password');
    }
  });
});

$(document).ready(function () {
  $('#btnToggle1').click(function () {
    const passwordInput1 = $('#RegisterForm-password');
    if (passwordInput1.attr('type') === 'password') {
      passwordInput1.attr('type', 'text');
    } else {
      passwordInput1.attr('type', 'password');
    }
  });

  $('#btnToggle2').click(function () {
    const passwordInput2 = $('#confirm_password');
    if (passwordInput2.attr('type') === 'password') {
      passwordInput2.attr('type', 'text');
    } else {
      passwordInput2.attr('type', 'password');
    }
  });

  $('#policy-tabs').owlCarousel({
    loop: false,
    nav: false,
    dots: false,
    autoWidth: true,
    responsive: {
      0: {
        items: 3,
        margin: 12,
      },
      600: {
        items: 5,
        margin: 20,
      },
    },
  });
});

jQuery(document).ready(function ($) {
  // for blog page toggle
  $('.hambar').on('click', function () {
    if ($('.hambar').parent().find('.links').hasClass('active')) {
      $('.hambar').parent().find('.links').removeClass('active');
    } else {
      $('.hambar').parent().find('.links').addClass('active');
    }
  });
});

// for cart quntity
jQuery(document).on('click', '.home-pro-card .quantity__button', function () {
  const newQuant = $(this).parent().find('input').val();
  $(this)
    .parent()
    .parent()
    .parent()
    .parent()
    .find('.my-product-quantity')
    .val(newQuant);
});
// for cart quntity for collection
jQuery(document).on(
  'click',
  '.card__information .quantity__button',
  function () {
    const newQuant = $(this).parent().find('input').val();
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .find('.my-product-quantity')
      .val(newQuant);
  }
);

// for collection page
$(document).on(
  'click',
  '.card__information .product-form__input--pill > label',
  function (e) {
    if (!$(this).hasClass('active')) {
      $(this).addClass('active').siblings('label').removeClass('active');
      // $(this)
      //   .parent()
      //   .parent()
      //   .parent()
      //   .parent()
      //   .find('.h-pro-price')
      //   .toggleClass('othr-var');
      setTimeout(() => {
        $(this)
          .parent()
          .find(`#${$(this).attr('for')}`)
          .click();
      }, 100);
      setTimeout(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const variantID = urlParams.get('variant');
        // $(this).parent().parent().parent().parent().find('input[name="product-id"]').val(variantID);
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find('input[name="id"]')
          .val(variantID);
      }, 150);
    }
  }
);

$(document).ready(function () {
  $('.category').click(function () {
    // Remove active class from all categories
    $('.category').removeClass('active');
    // Add active class to the clicked category
    $(this).addClass('active');
  });
});

jQuery(document).ready(function ($) {
  if (window.location.pathname.includes('collections')) {
    const url = window.location.pathname;
    $(`#category-slider a[href="${url}"]`).parent().addClass('active');
  }

  $('#category-slider').owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    margin: 15,
    autoWidth: true,
    responsive: {
      768: {
        margin: 68,
      },
    },
  });
});

jQuery(document).ready(function ($) {
  if (window.location.pathname == '/' && window.innerWidth <= 991) {
    $('.home-pro-tabs-cnt .owl-dots').css(
      'max-width',
      parseFloat($('.h-bnr-car .owl-dots').css('width')) - 40 + 'px'
    );
    $('.home-pro-tabs-cnt .container a').css(
      'margin-left',
      parseFloat($('.h-bnr-car .owl-dots').css('width')) / 2 - 75 + 'px'
    );
  }
});

jQuery(document).ready(function ($) {
  $('.header__icon').on('click', function () {
    $(
      '.menu-drawer__navigation .huk_menu_item_level_2.huk_menu_item_has_child'
    ).addClass('huk_menu_item_active');
    $('.hdr-collection-menu').parent().parent().addClass('hdr-ingre');
  });

  $('body').on('click', function (event) {
    // for filter dropdowns
    // console.log($(event.target).closest('.blog-filter ul').length)
    if (
      !$(event.target).closest('.blog-filter ul').length &&
      !$(event.target).hasClass('blog-selected-value')
    ) {
      $('.blog-filter ul').removeClass('active');
    }
  });

  $('.header__icon--cart').css('pointer-events', 'auto');
  $('.header__icon--cart').on('click', function () {
    $('cart-drawer.drawer').css('display', 'flex');
    // $('body').addClass('overflow-hidden');
  });

  $('.column.quarter').filter(function () {
    return $.trim($(this).text()) === '';
  }).css('display', 'none');


  $(document).ready(function () {

    function updateCartDisplay(cart) {
      // Update the cart display in the UI
      // This could be updating the cart icon count or refreshing the cart view
      console.log('Updated cart:', cart);
    }


    const loadMoreButton = document.querySelector('.load-more-button');
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function (event) {
        event.preventDefault();

        const nextPageUrl = this.getAttribute('data-next-page-url');
        const spinner = this.querySelector('.loading__spinner');

        if (nextPageUrl) {
          // Add loading state
          loadMoreButton.classList.add('loading');
          if (spinner) {
            spinner.classList.remove('hidden');
          }

          fetch(nextPageUrl)
            .then((response) => response.text())
            .then((html) => {
              const parser = new DOMParser();
              const nextPage = parser.parseFromString(html, 'text/html');

              const productGrid = document.querySelector('#product-grid');

              if (productGrid && nextPage) {
                const newProductItems = nextPage.querySelectorAll('#product-grid li');

                newProductItems.forEach((item) => {
                  productGrid.appendChild(item);
                });

                $.ajax({
                  type: 'GET',
                  url: '/cart.js',
                  dataType: 'json',
                  success: function (cart) {
                    updateVariantQuantities(cart);
                  },
                  error: function (xhr, status, error) {
                    console.error('Error fetching cart:', error);
                  }
                });

                const newLoadMoreButton = nextPage.querySelector('.load-more-button');

                if (newLoadMoreButton) {
                  loadMoreButton.setAttribute('data-next-page-url', newLoadMoreButton.getAttribute('data-next-page-url'));
                } else {
                  loadMoreButton.parentNode.removeChild(loadMoreButton);
                }
              }

              // Remove loading state
              loadMoreButton.classList.remove('loading');
              if (spinner) {
                spinner.classList.add('hidden');
              }
            })
            .catch((error) => {
              console.error('Error fetching next page:', error);

              // Remove loading state in case of error
              loadMoreButton.classList.remove('loading');
              if (spinner) {
                spinner.classList.add('hidden');
              }
            });
        }
      });
    }
  });


  // Fetch the cart content
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cart) {
      updateVariantQuantities(cart);
      // var cart_count = cart.item_count;  
      // $('body').attr('data-cart_count', cart_count); 
    },
    error: function (xhr, status, error) {
      console.error('Error fetching cart:', error);
    }
  });

  // Function to update variant quantities  
  function updateVariantQuantities(cart) {
    cart.items.forEach(function (item) {
      const variantId = item.variant_id;
      const quantity = item.quantity;
      // Update the input field with the corresponding variant ID
      $('[data-qty-variant-id="' + variantId + '"] .quantity__input').val(quantity);
      if (quantity == 5) {
        $('[data-qty-variant-id="' + variantId + '"] .plus-btn').addClass('cart-limit-reached');
        console.log('variantId cart limit: ' + variantId);
      }
      // Code for PDP Limit
      // checks when we land to pdp from any other page
      let pdpAtc = document.querySelector('.pdp-atc');
      let pdpQtyBtn = document.querySelector('.pdp-quantity-selector[data-qty-variant-id="' + variantId + '"]')
      if (pdpAtc) {
        let pdpInputValue = Number(pdpAtc.querySelector('.product-variant-id').value);
        if (pdpAtc) {
          if (pdpInputValue == variantId) {
            if (quantity === 0) {
              pdpAtc.classList.remove('hidden');
              pdpQtyBtn.classList.add('hidden');
            } else {
              pdpAtc.classList.add('hidden');
              pdpQtyBtn.classList.remove('hidden');
            }
          }
        }
      }
      console.log('variantId ajax check: ' + variantId);

      // $('[data-qty-variant-id="' + variantId + '"]').addClass('active');


      $('.h-pro-card-cnt, .home-pro-card').each(function () {
        const $quantityElements = $(this).find('.product-form__quantity');
        const $quantityElementsActive = $(this).find('.product-form__quantity.active');
        let activeCount = 0;
        const variantPill = $(this).find('.hm-pro-variant label.active');
        const variantPillId = variantPill.attr('data-variant-id');

        if ($quantityElements.length > 1) {
          $quantityElementsActive.each(function () {
            const $this = $(this);
            const $quantityElementsVariantId = $this.attr('data-qty-variant-id');

            if (variantPillId != $quantityElementsVariantId) {
              $('[data-qty-variant-id="' + $quantityElementsVariantId + '"]').removeClass('active');
            }
          });
        }



        $quantityElements.each(function () {
          if ($(this).hasClass('active')) {
            activeCount++;
          }
        });

        if (activeCount > 1) {
          // Perform your desired action here
          console.log('More than one active element found in card:', this);

          // Example action: Add a new class
          $(this).find('.product-form__quantity').first().addClass('both-variant-found');
        }
        // if (activeCount == 2) {
        //    $('[data-variant-id="' + variantId + '"]').siblings().removeClass('active');
        //     $('[data-variant-id="' + variantId + '"]').addClass('active'); 
        // }
      });
    });
  }

  // Function to check if a variant is found in the cart
  async function variantFoundInCart(variantId) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.items.some((item) => item.variant_id == variantId);
    } catch (error) {
      console.error('Error fetching cart:', error);
      return false;
    }
  }

  function variantFoundInCartToDelete(variantId) {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (cart) {
        return cart.items.some((item) => item.variant_id == variantId);
      },
      error: function (xhr, status, error) {
        console.error('Error fetching cart:', error);
      }
    });
  }

  $(document).on('click', '.quantity__button[name=\'plus\'], .quantity__button[name=\'minus\']', function () {
    let cartCheckoutButton = document.querySelector('.gokwik-checkout');
    // if(cartCheckoutButton) {
    //   cartCheckoutButton.setAttribute('aria-disabled',"true");
    //   cartCheckoutButton.style.pointerEvents = "none";
    // }
    const cart_var_id = $(this).parents('.cart-quantity').find('.quantity__input').data('quantity-variant-id');
    const cart_var_qty = $(this).parents('.cart-quantity').find('.quantity__input').val();
    $('[data-qty-variant-id="' + cart_var_id + '"] .quantity__input').val(cart_var_qty);
    if (cart_var_qty < 5) {
      $('[data-qty-variant-id="' + cart_var_id + '"] .quantity__button[name="plus"]').removeClass('cart-limit-reached');
    } else {
      $('[data-qty-variant-id="' + cart_var_id + '"] .quantity__button[name="plus"]').addClass('cart-limit-reached');
    }
    setTimeout(() => {
      fetchCheckoutData();
    }, 3000);
  });

  $(document).on('click', '.quantity__button[name=\'minus\']', function () {
    let cartCheckoutButton = document.querySelector('.gokwik-checkout');
    // if(cartCheckoutButton) {
    //   cartCheckoutButton.setAttribute('aria-disabled',"true");
    //   cartCheckoutButton.style.pointerEvents = "none";
    // }
    const cart_var_id = $(this).parents('.cart-quantity').find('.quantity__input').data('quantity-variant-id');
    const cart_var_qty = $(this).parents('.cart-item').find('.quantity__input').val();
    console.log('cart_var_qty: ' + cart_var_qty);
    if (cart_var_qty == 0) {
      $('[data-qty-variant-id="' + cart_var_id + '"]').removeClass('active');
    }
    if (cart_var_qty < 5) {
      console.log('cart_var_qty less than 5: ' + cart_var_qty);
      setTimeout(function () {
        $('[data-qty-variant-id="' + cart_var_id + '"]').find('.plus-btn').removeClass('cart-limit-reached');
      }, 1800);
    }
    setTimeout(() => {
      fetchCheckoutData();
    }, 3000);
  });

  $(document).on('click', '.cart-remove-button', function () {
    let cartCheckoutButton = document.querySelector('.gokwik-checkout');
    // if(cartCheckoutButton) {
    //   cartCheckoutButton.setAttribute('aria-disabled',"true");
    //   cartCheckoutButton.style.pointerEvents = "none";
    // }
    const variantId = $(this).data('variant-id');
    console.log('variantId ' + variantId);
    if (!variantFoundInCartToDelete(variantId)) {
      setTimeout(() => {
        $('[data-qty-variant-id="' + variantId + '"] .quantity__input').val(1);
        $('[data-qty-variant-id="' + variantId + '"] ').removeClass('active');
        $('[data-qty-variant-id="' + variantId + '"] ').find('.plus-btn').removeClass('cart-limit-reached');
        $('[data-qty-variant-id="' + variantId + '"] ').find('.plus-btn').removeAttr('disabled');
      }, 1800)
    }
  });


  function variantqty_switcher(current) {
    if (!(current.parents('.home-prd-car').hasClass('h-spotlight-cnt')) && !(current.parents('.home-prd-car').hasClass('home-prd-car-drawer'))) {
      const isInCart = current.hasClass('cart-button');
      if (!isInCart) {
        $('cart-drawer.drawer').css('display', 'none');
      }
    }

    const selected_variant = current.parents('.home-pro-card').find('.product-variant-id').val();
    const $this = current;
    if (!current[0].classList.contains('notify-me'))
      setTimeout(() => {
        const intervalId = setInterval(function () {
          if ($this.attr('aria-disabled') == undefined) {
            $('body').removeClass('overflow-hidden');
            current.parents('.home-pro-card').find('.product-form__quantity[data-qty-variant-id=' + selected_variant + ']').addClass('active');

            clearInterval(intervalId);
          }
        }, 200);
      }, 350);
  }

  $('body').on('click', '.hm-pro-variant label', function () {
    const selected_variant = $(this).data('variant-id');
    const current_variant_qty = $(this);
    console.log('selected_variant in cart check: ' + selected_variant);
    // current_variant_qty.parents('.home-pro-card').find('.product-form__submit').css('opacity', 0);   
    // changed
    const current_var_qty = current_variant_qty.parents('.home-pro-card').find('.product-form__quantity[data-qty-variant-id=' + selected_variant + '] input').val();
    console.log('selected_variant in ' + current_var_qty);
    current_variant_qty.parents('.home-pro-card').find('.my-product-quantity').val(current_var_qty);
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (cart) {
        cart.items.forEach(function (item) {
          const variantId = item.variant_id;
          const quantity = item.quantity;
          if (selected_variant == variantId) {
            current_variant_qty.parents('.home-pro-card').find('.product-form__quantity[data-qty-variant-id=' + selected_variant + ']').addClass('active');
            current_variant_qty.parents('.buy-now').find('.product-form__quantity[data-qty-variant-id=' + selected_variant + ']').addClass('active');
          }
        });
      },
      error: function (xhr, status, error) {
        console.error('Error fetching cart:', error);
      }
    });
  });

  // add to cart
  $(document).on('click', '.home-prd-car .product-form__submit', function () {
    const current_btn = $(this);
    variantqty_switcher(current_btn);
    $(this).parents('.home-prd-car').find('.minus-btn').removeAttr('disabled');
  });

  // $('.h-spotlight-cnt .product-form__submit').on('click', function (event) {
  //   const current_btn = $(this);
  //   variantqty_switcher(current_btn);
  //   $(this).parents('.home-prd-car').find('.minus-btn').removeAttr('disabled');
  // });

  $(document).on('click', '.buy-now .product-form__buttons button', function () {
    const current_btn = $(this);
    variantqty_switcher(current_btn);
    $(this).parents('.buy-now').find('.minus-btn').removeAttr('disabled');
  });

  const intervalId = setInterval(function () {
    console.log('test atc added');
    $('.yotpo-reviews-pagination-container').append('<button class="back-to-mobile">Back to   reviews</button>');
    clearInterval(intervalId);
    console.log('test atc added 2');
  }, 5000);

  $(document).on('click', '.back-to-mobile', function () {
    const sectionId = '#yotpo-reviews-container';
    $('html, body').animate({
      scrollTop: $(sectionId).offset().top - 230,
      behavior: 'smooth'
    }, 100);
  });

  //  max limit code globally on site starts here

  // const maxQuantity = 27; // Maximum quantity allowed
  // // Function to check cart quantity at intervals
  // setInterval(function () {
  //   fetch('/cart.json')
  //     .then((response) => response.json())
  //     .then((cartData) => {
  //       const totalQuantity = cartData.item_count;
  //       console.log(totalQuantity);
  //       // Check if cart quantity reaches 25
  //       if (totalQuantity >= maxQuantity) {
  //         $('.product-form__submit').addClass('max-cart-disable');
  //         $('.max-limit-button').removeClass('max-cart-error');
  //         $('.plus-btn').addClass('cart-limit-reached');
  //         $('.quantity__button[name="plus"]').addClass('cart-limit-reached');
  //       } else {
  //         $('.product-form__submit').removeClass('max-cart-disable');
  //         $('.max-limit-button').addClass('max-cart-error');
  //         $('.quantity__button[name="plus"]').remove('cart-limit-reached');
  //         $('.minus-btn').on('click', function () {
  //           const qty_val = $(this).parents('.quantity').find('.quantity__input').val();
  //           if (qty_val != 5) {
  //             $(this).parents('.quantity').find('.plus-btn').removeClass('cart-limit-reached');
  //           }
  //         });
  //       }
  //     });
  // }, 500);

  // $(document).on('click', '.max-limit-button', function () {
  //   $(this).parents('.product-form').find('.product-form__error-message-wrapper').removeAttr('hidden');
  //   $(this).parents('.product-form').find('.product-form__error-message').text('Maximum 25 Products can be added into cart');
  //   alert('Maximum 25 Products can be added into cart');
  //   setTimeout(function () {
  //     $('.add-to-cart-pop').addClass('active');
  //     $('.add-to-cart-pop').html('Maximum 25 Products can be added into cart');
  //   }, 200);
  //   setTimeout(function () {
  //     $('.add-to-cart-pop').removeClass('active');
  //     setTimeout(function () {
  //       $('.add-to-cart-pop').html('<h4>Product added to cart</h4><a href="/cart">View cart</a>');
  //     }, 800);
  //   }, 4000);
  // });

  // $(document).on('click', '.quantity__button[name=\'plus\']', function () {
  //   $.ajax({
  //     type: 'GET',
  //     url: '/cart.js',
  //     dataType: 'json',
  //     success: function (cart) {
  //       if (cart.item_count == 26) {
  //         $('.add-to-cart-pop').addClass('active');
  //         $('.add-to-cart-pop').html('Maximum 25 Products can be added into cart');

  //         setTimeout(function () {
  //           $('.add-to-cart-pop').removeClass('active');
  //           $('.add-to-cart-pop').html('<h4>Product added to cart</h4><a href="/cart">View cart</a>');
  //         }, 4000);
  //       }
  //     },
  //     error: function (xhr, status, error) {
  //       console.error('Error fetching cart:', error);
  //     }
  //   });
  // });

  //  max limit code globally on site ends here

  // function to show product details tab as per variants 

  $('.product__info-wrapper variant-selects label').on('click', function () {
    setTimeout(() => {
      const currentvariant = $('.product__info-wrapper variant-selects  input[name="Size"]:checked').val();
      console.log('initialVariant: ' + currentvariant);
      $('.variant-details-tbl').hide();
      $('.variant-details-tbl').each(function (index, item) {
        const variant_details_data = $(this).data('variant-match');
        const current = $(this);
        console.log('initialVariant: ' + variant_details_data);
        if (currentvariant == variant_details_data) {
          current.show();
        }
      });
    }, 200);
  });

  // Code for PDP Limit
  async function variantInCart(variantId) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.items.some(item => {
        if (item.variant_id == variantId) {
          return variantId
        }
      });
    } catch (error) {
      console.error('Error fetching cart:', error);
      return false;
    }
  }

  // Code for PDP Limit
  // checks when ever we switch the variant
  document.querySelectorAll('.product__info-wrapper variant-selects label').forEach(function (label) {
    label.addEventListener('click', async function () {
      const selectedVariant = document.querySelector('.product__info-wrapper variant-selects input[name="Size"]:not(:checked)');
      let selectedVariantId = selectedVariant.nextElementSibling.dataset.variantId;
      let pdpAtc = document.querySelector('.pdp-atc');
      let quantitySelectors = Array.from(document.querySelectorAll('.pdp-quantity-selector'));
      let pdpNotifyMe = document.querySelector('.pdp-notify-me');
      for (const quantityElement of quantitySelectors) {
        pdpAtc.classList.add('hidden');
        quantityElement.classList.add('hidden');
        if (quantityElement.dataset.qtyVariantId == selectedVariantId) {
          let found = await variantInCart(Number(selectedVariantId));
          if (found) {
            quantityElement.classList.remove('hidden');
            pdpAtc.classList.add('hidden');
          } else {
            quantityElement.classList.add('hidden');
            if (pdpAtc.dataset.available == "true") {
              pdpAtc.classList.remove('hidden');
            } else {
              pdpNotifyMe.classList.add('hidden');
            }
          }
        }
      }
    });
  });



  $(document).on('click', '.card__content .product-form__submit', function () {
    const current_btn = $(this);
    variantqty_switcher(current_btn);
    $(this).parents('.home-prd-car').find('.minus-btn').removeAttr('disabled');
  });

  // for collection page

  $('.card__content .quantity button').on('click', function () {
    const op = $(this).attr('name');
    const text = $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .find('h3 a')
      .text()
      .trim();

    if (op == 'minus') {
      // deleteFromQuantity($(this));
    }

    $('.drawer__cart-items-wrapper .cart-item').each((index, item) => {
      if ($(item).find('.cart-item__details .cart-item__name').text() == text) {
        // $(item).find(`.cart-item__quantity button[name=${op}]`).click();
      }
    });
  });

  // toggle coupon
  $('.cart-coupon-close').on('click', function () {
    $('.cart-coupon-wrapper').removeClass('active');
    $('.drawer__inner').removeClass('overflow-hidden');
  });

  // select coupon
  $('.cart-coupon-body button').on('click', function () {
    $('#discount-code-input').val(
      $(this).parent().parent().find('input').val()
    );
    $('#apply-discount-btn').click();
  });

  // Handle search icon click on mob-form
  $(document).on('click', '.mob-form button', function (e) {
    const $form = $(this).closest('.mob-form');
    const $input = $form.find('input');

    if (!$form.hasClass('active')) {
      e.preventDefault();
      e.stopPropagation();
      $form.addClass('active');
      setTimeout(function () {
        $input.trigger('focus');
      }, 50);
    } else {
      if (!$input.val().trim()) {
        e.preventDefault();
        $form.removeClass('active');
      }
    }
  });

  // Close search when clicking outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.mob-form, .wizzy-autocomplete-wrapper').length) {
      $('.mob-form').removeClass('active');
    }
  });

  // Close search on Escape key
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      $('.mob-form').removeClass('active');
      if (typeof wizzyConfig !== 'undefined') {
        $('.wizzy-autocomplete-wrapper').hide();
      }
    }
  });

  // popups
  // cookie
  const cookiesAlert = $('#cookies-alert');
  const acceptCookiesBtn = $('#accept-cookies-btn');
  const preferenceCookiesBtn = $('#preference-btn');
  // Check if cookies have been accepted
  const cookiesAccepted = localStorage.getItem('cookiesAccepted');
  setTimeout(function () {
    if (!cookiesAccepted) {
      cookiesAlert.css('display', 'block');
    }
  }, 10000);
  acceptCookiesBtn.on('click', function () {
    localStorage.setItem('cookiesAccepted', true);
    cookiesAlert.css('display', 'none');
  });
  preferenceCookiesBtn.on('click', function () {
    localStorage.setItem('cookiesAccepted', true);
    cookiesAlert.css('display', 'none');
  });
  cookiesAlert.css(
    'left',
    parseInt($('.newsletter .container').css('margin-left'))
  );

  // offer popup
  // Check if the popup should be displayed
  var popupShown = localStorage.getItem('offerPopupShown');
  if (!popupShown) {
    document.getElementById('offer-popup').classList.remove('d-none');
    document
      .getElementById('unlock-btn')
      .addEventListener('click', function () {
        document.getElementById('offer-popup').classList.add('d-none');
        localStorage.setItem('offerPopupShown', true);
        if ('Notification' in window) {
          Notification.requestPermission().then(function (permission) { });
        }
      });
    document.getElementById('later-btn').addEventListener('click', function () {
      document.getElementById('offer-popup').classList.add('d-none');
      localStorage.setItem('offerPopupShown', true);
    });
  }

  $('#offer-popup').css(
    'right',
    parseInt($('.newsletter .container').css('margin-right'))
  );

  // 3rd popup
  // Check if the popup should be displayed
  var popupShown = localStorage.getItem('popupShown');
  if (!popupShown) {
    // Show the popup
    document.getElementById('popup-container').classList.add('show');

    document
      .getElementById('close-popup')
      .addEventListener('click', function () {
        document.getElementById('popup-container').classList.remove('show');
        // Set flag in local storage to indicate that the popup has been shown
        localStorage.setItem('popupShown', true);
      });
    document.getElementById('main-btn').addEventListener('click', function () {
      // Close the popup
      document.getElementById('popup-container').classList.remove('show');
      // Set flag in local storage to indicate that the popup has been shown
      localStorage.setItem('popupShown', true);
    });
  }

  $('#popup-container').css(
    'right',
    parseInt($('.newsletter .container').css('margin-right'))
  );
});


// Wait for the document to be fully loaded
document.addEventListener('DOMContentLoaded', function () {
  // Initialize Owl Carousel
  function dealslider() {
    $('.home-prd-car-drawer').owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: false,
      autoWidth: true,
      stagePadding: 20,
      center: false,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
      ],
      responsive: {
        0: {
          items: 1,
          nav: false,
          dots: true,
          autoWidth: true
        },
        768: {
          items: 2,
          autoWidth: true,
          margin: 4
        },
        1200: {
          items: 3,
          margin: 4
        },
      },
    });
  }
  // When the AJAX cart drawer opens, refresh the Owl Carousel
  $('.header__icon--cart').on('click', function () {
    $('.home-prd-car-drawer').owlCarousel('destroy');
    dealslider();
  });
});

//* This code belongs to cart-drawers deal of the day section

// initialize cart carousel
// function initializeCartCarousel($this) {
//   const intervalId = setInterval(function () {
//     if ($this.attr("aria-disabled") == undefined) {
//       $(".home-prd-car-drawer").owlCarousel("destroy");
//       $(".home-prd-car-drawer").owlCarousel({
//         loop: false,
//         margin: 7,
//         nav: true,
//         dots: false,
//         autoWidth: true,
//         stagePadding: 20,
//         center: false,
//         navText: [
//           '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
//           '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
//         ],
//         responsive: {
//           0: {
//             items: 2,
//             nav: false,
//             dots: true,
//             autoWidth: true,
//           },
//           768: {
//             items: 4,
//             autoWidth: true,
//           },
//           1200: {
//             items: 5,
//             margin: 20,
//           },
//         },
//       });

//       clearInterval(intervalId);
//     }
//   }, 200);
// }

//* This code belongs to cart-drawers offers available

// $(".buy3at1399-car").owlCarousel({
//   loop: false,
//   margin: 7,
//   dots: true,
//   responsive: {
//     0: {
//       items: 2,
//     },
//   },
// });



// toggle coupon
// $(document).on('click', '.cart-coupon-button', function (e) {
//   $('.cart-coupon-wrapper').toggleClass('active');
//   // event listener for coupon apply button
//   const discountCouponApplyBTN = document.querySelector('#apply-discount-btn');
//   discountCouponApplyBTN.addEventListener('click', function(event) {
//     event.preventDefault(); // Prevent the default form submission
//     handleCoupons();
//   });
// });

// $(document).on('click', '.cart-coupon-close', function (e) {
//   $('.cart-coupon-wrapper').removeClass('active');
//   $('.drawer__inner').removeClass('overflow-hidden');
//   // remove event listener for coupon apply button
//   const discountCouponApplyBTN = document.querySelector('#apply-discount-btn');
//   discountCouponApplyBTN.removeEventListener('click', handleCoupons);
// });

// async function cartData() {
//   const res = await fetch('/cart.js');
//   const response = await res.json();
//   return response;
// }

// async function handleCoupons() {
//   let cart = await cartData();
//   let cartCouponCode = cart.cart_level_discount_applications[0]?.title;
//   let code = document.querySelector('#discount-code-input').value;
//   if(code){
//     applyDiscount(code);
//   } else if(cartCouponCode){
//     applyDiscount(cartCouponCode);
//   } else {
//     let cartCuponText = document.querySelector('.cart-coupon-button text');
//       if(cartCuponText){
//         cartCuponText.innerHTML = `APPLY COUPONS`; 
//       }
//   }
// }

$(document).on(
  'change',
  '.home-prd-car-drawer .h-pro-quant input',
  function (e) {
    $(this).parent().parent().find('.product-variant-id').val($(this).val());
    // $(this).parent().parent().find('.h-pro-price').toggleClass('othr-var');
  }
);

$(document).on('click', '.cart-coupon-apply', function (e) {
  $('#discount-code-input').val($(this).parent().parent().find('input').val());
  $('#apply-discount-btn').click();
});

// toggle offer card 
$(document).on('click', '.buy1399-toggle', function (e) {
  const offerToggleClass = $(this).data('offer-toggle');
  $(this).find('svg').toggleClass('rotated');
  $('.' + offerToggleClass).toggleClass('active');
});

// coupon code
let authorization_token;

const checkoutContainer = document.createElement('div');
document.body.appendChild(checkoutContainer);

// Apply the discount if it exists in localStorage
// if (localStorage.discountCode) {
//   applyDiscount(JSON.parse(localStorage.discountCode).code);
// }

// Use event delegation for dynamically added elements
// document.addEventListener("click", function (event) {
//   // if (event.target.matches("#apply-discount-btn")) {
//   //   event.preventDefault();
//   // }

//   if (event.target.matches("#clear-discount-btn")) {
//     event.preventDefault();
//     clearDiscount();
//   }
// });

function clearDiscount() {
  document.querySelector(
    "#applied-discount-code .applied-discount-code-value"
  ).innerHTML = "";
  document.querySelector("#discount-code-error").innerHTML = "";
  clearLocalStorage();
  fetch('/checkout?discount=%20');
}

function clearLocalStorage() {
  if (
    document.querySelector(
      '#applied-discount-code .applied-discount-code-wrapper'
    )
  ) {
    document.querySelector(
      '#applied-discount-code .applied-discount-code-wrapper'
    ).style.display = 'none';
  }
  if (document.querySelector('.cart__subtotal .money')) {
    document.querySelector('.cart__subtotal .money').innerHTML = JSON.parse(
      localStorage.discountCode
    ).totalCart;
  }
  localStorage.removeItem('discountCode');
}

async function validateDiscountRules() {
  const totalPrice = parseInt(document.querySelector('.cart-drawer__footer .totals__total-value').innerHTML.replace('₹', ''));
  if (totalPrice < 1000) {
    const prevAppliedDiscount = localStorage.getItem('discountCode');
    if (prevAppliedDiscount) {
      localStorage.removeItem('discountCode');

      // Call the function to delete the discount cookie
      await deleteCookie('discount_code');
      // await removeDiscount();
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      await fetch('/cart.json')
        .then((response) => response.json())
        .then((response) => {
          cart.renderContents(response);
        });
    }
  }
}

// Function to delete a cookie using .then() and .catch()
async function deleteCookie(name) {
  try {
    const result = await cookieStore.delete(name);
  } catch (error) {
    console.error(`Error deleting cookie '${name}':`, error);
  }
}


document.addEventListener('DOMContentLoaded', async () => {
  const storedDiscount = JSON.parse(localStorage.getItem('discountCode'));
  if (!storedDiscount || !storedDiscount.code) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const appliedDiscounts = cart.discount_codes || [];
    const discountMatched = appliedDiscounts.some(
      d => d.code.toLowerCase() === storedDiscount.code.toLowerCase() && d.applicable !== false
    );

    const hasScriptDiscount = cart.items.some(item =>
      item.line_level_discount_allocations?.some(
        alloc => alloc.discount_application?.type === 'script'
      )
    );

    if (!discountMatched || hasScriptDiscount) {
      // Remove local state if no longer valid
      localStorage.removeItem('discountCode');
      await deleteCookie('discount_code');
      // await removeDiscount();

      const couponText = document.querySelector('.cart-coupon-button text');
      if (couponText) couponText.innerHTML = `APPLY COUPONS`;
      return;
    }

    // Discount is valid — update UI just like in applyDiscount()
    const discountTitle = storedDiscount.code;
    const couponText = document.querySelector('.cart-coupon-button text');
    const couponInput = document.querySelector("#discount-code-input");
    const offerElement = document.querySelector('.offer-by-total');

    if (couponText) couponText.innerHTML = `${discountTitle} APPLIED`;
    if (couponInput) couponInput.value = discountTitle;

    // Optional: Show "conflict with other offer" message if needed
    // if (offerElement) {
    //   offerElement.style.display = 'none';
    //   if (!document.querySelector('.offer-message')) {
    //     offerElement.insertAdjacentHTML('afterend', '<div class="offer-message">B2G1 cannot be applied with your existing discount</div>');
    //   }
    // }

    // Update cart pricing UI
    const priceTotal = document.querySelector('.price-details h4 span:last-child');
    const subTotal = document.querySelector('.price-details .subtotal');
    const discountPrice = document.querySelector('.price-details .discount-price');
    const cartSavings = document.querySelector('.cart-saving span');
    const footerNetPayable = document.querySelector('.cart-drawer__footer .totals__total-value');
    const cartCouponHeader = document.querySelector('.cart-coupon-header h2 span');
    const appliedDiscountCodeValue = document.querySelector('#applied-discount-code .applied-discount-code-value');
    const appliedDiscountCodeWrapper = document.querySelector('#applied-discount-code .applied-discount-code-wrapper');
    const applyDiscountButton = document.querySelector('#apply-discount-btn');

    const regularTotal = parseInt(subTotal?.innerText.replace(/[^\d]/g, '') || 0);
    const totalPrice = parseInt(cart.total_price);
    const formattedTotal = `₹${(totalPrice / 100).toLocaleString()}`;
    const discountAmount = regularTotal - totalPrice / 100;

    if (priceTotal) priceTotal.innerHTML = formattedTotal;
    if (discountAmount > 0) {
      if (discountPrice) discountPrice.innerHTML = `-₹${discountAmount.toLocaleString()}`;
      document.querySelector('.discount-price-container').classList.remove('hidden');
    }
    if (cartSavings) cartSavings.innerHTML = discountAmount.toLocaleString();
    if (footerNetPayable) footerNetPayable.innerHTML = formattedTotal;
    if (cartCouponHeader) cartCouponHeader.innerHTML = `Your cart total: ${formattedTotal}`;
    if (appliedDiscountCodeValue) appliedDiscountCodeValue.innerHTML = `${discountTitle.toUpperCase()} applied`;
    if (appliedDiscountCodeWrapper) appliedDiscountCodeWrapper.style.display = 'inline';
    if (applyDiscountButton) {
      applyDiscountButton.innerHTML = 'APPLIED';
      applyDiscountButton.style.pointerEvents = 'all';
    }

  } catch (error) {
    console.error('Error restoring coupon UI on page load:', error);
  }
});



function applyDiscount(code) {
  if (code == undefined) {
    return;
  } else {
    const applyDiscountButton = document.querySelector('#apply-discount-btn');
    const couponSuccessWrapper = document.querySelector('#coupon-success-msg');

    if (applyDiscountButton) {
      applyDiscountButton.innerHTML = 'APPLYING <div class="loader"></div>';
      applyDiscountButton.style.pointerEvents = 'none';
    }

    // Step 1: Check if any script-based line discount exists
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const hasScriptDiscount = cart.items.some(item =>
          item.line_level_discount_allocations &&
          item.line_level_discount_allocations.some(
            alloc => alloc.discount_application?.type === 'script'
          )
        );

        if (hasScriptDiscount) {
          if (couponSuccessWrapper) {
            couponSuccessWrapper.innerHTML = 'BUY3@1399/BUY4@1799 is already applied. Coupons cannot be combined.';
            couponSuccessWrapper.style.display = 'block';
            couponSuccessWrapper.style.color = 'red';
            setTimeout(() => {
              couponSuccessWrapper.style.display = 'none';
            }, 3000);
          }

          if (applyDiscountButton) {
            applyDiscountButton.innerHTML = 'APPLY';
            applyDiscountButton.style.pointerEvents = 'all';
          }

          return; // Skip applying code
        }

        // Step 2: Apply discount code via iframe
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = `/discount/${code}?redirect=/cart`;
        document.body.appendChild(iframe);

        iframe.onload = () => {
          setTimeout(() => {
            fetch('/cart.js')
              .then(res => res.json())
              .then(updatedCart => {
                const appliedDiscounts = updatedCart.discount_codes || [];
                const discountMatched = appliedDiscounts.some(d => d.code.toLowerCase() === code.toLowerCase() && d.applicable !== false);

                if (!discountMatched) {
                  if (couponSuccessWrapper) {
                    couponSuccessWrapper.innerHTML = 'Coupon cannot be applied.';
                    couponSuccessWrapper.style.display = 'block';
                    couponSuccessWrapper.style.color = 'red';
                    setTimeout(() => {
                      couponSuccessWrapper.style.display = 'none';
                    }, 3000);
                  }

                  if (applyDiscountButton) {
                    applyDiscountButton.innerHTML = 'APPLY';
                    applyDiscountButton.style.pointerEvents = 'all';
                  }

                  localStorage.removeItem('discountCode');
                  return;
                }

                // Discount applied — update UI
                const priceTotal = document.querySelector('.price-details h4 span:last-child');
                const subTotal = document.querySelector('.price-details .subtotal');
                const discountPrice = document.querySelector('.price-details .discount-price');
                const cartSavings = document.querySelector('.cart-saving span');
                const footerNetPayable = document.querySelector('.cart-drawer__footer .totals__total-value');
                const cartCouponHeader = document.querySelector('.cart-coupon-header h2 span');
                const appliedDiscountCodeValue = document.querySelector('#applied-discount-code .applied-discount-code-value');
                const appliedDiscountCodeWrapper = document.querySelector('#applied-discount-code .applied-discount-code-wrapper');

                const regularTotal = parseInt(subTotal?.innerText.replace(/[^\d]/g, '') || 0);
                const totalPrice = parseInt(updatedCart.total_price);
                const formattedTotal = `₹${(totalPrice / 100).toLocaleString()}`;
                const discountAmount = regularTotal - totalPrice / 100;



                if (priceTotal) priceTotal.innerHTML = formattedTotal;
                if (discountAmount > 0) {
                  if (discountPrice) discountPrice.innerHTML = `-₹${discountAmount.toLocaleString()}`;
                  document.querySelector('.discount-price-container').classList.remove('hidden');
                }
                if (cartSavings) cartSavings.innerHTML = discountAmount.toLocaleString();
                if (footerNetPayable) footerNetPayable.innerHTML = formattedTotal;
                if (cartCouponHeader) cartCouponHeader.innerHTML = `Your cart total: ${formattedTotal}`;
                if (appliedDiscountCodeValue) appliedDiscountCodeValue.innerHTML = `${code.toUpperCase()} applied`;
                if (appliedDiscountCodeWrapper) appliedDiscountCodeWrapper.style.display = 'inline';

                if (couponSuccessWrapper) {
                  couponSuccessWrapper.innerHTML = 'Coupon applied!';
                  couponSuccessWrapper.style.display = 'block';
                  couponSuccessWrapper.style.color = '#413f47';
                  setTimeout(() => {
                    couponSuccessWrapper.style.display = 'none';
                  }, 3000);
                }

                if (applyDiscountButton) {
                  applyDiscountButton.innerHTML = 'APPLIED';
                  applyDiscountButton.style.pointerEvents = 'all';
                }

                localStorage.setItem('discountCode', JSON.stringify({
                  code: code.trim(),
                  nowValue: totalPrice / 100,
                  nowDiscount: discountAmount,
                  totalCartValue: regularTotal
                }));

                const storedDiscount = JSON.parse(localStorage.getItem('discountCode'));
                const discountTitle = storedDiscount.code;
                const couponText = document.querySelector('.cart-coupon-button text');
                const couponInput = document.querySelector("#discount-code-input");
                const offerElement = document.querySelector('.offer-by-total');

                if (couponText) couponText.innerHTML = `${discountTitle} APPLIED`;
                if (couponInput) couponInput.value = discountTitle;

              });
          }, 1000);
        };
      });
  }
}

// change variant images
jQuery(document).ready(function ($) {
  $('body').on('click', '.hm-pro-variant label', function (e) {
    const inputs = $(this).parents('.home-pro-card-2').find('input[data-varient]');
    const img = $(this).parents('.home-pro-card-2').find('img.product-image');
    const var_img = $(this).attr('data-variant-img');
    const current_url = window.location.href;
    const variant_title = $(this).html().split('<span')[0].trim();
    const offer_tag_variant = $(this).parents('.home-pro-card').find('.ofr-tag').data('offer-tag');
    const current = $(this);
    $(this).parents('.home-pro-card').find('.ofr-tag').each(function () {
      const offer_tag_variant = $(this).data('offer-tag');
      console.log(variant_title);
      console.log(offer_tag_variant);
      // commented this code bcz buy3tag on product card was getting removed when we change the variant
      // if (variant_title == offer_tag_variant) {
      //   setTimeout(function () {
      //     current.parents('.home-pro-card').find('.ofr-tag[data-offer-tag="' + offer_tag_variant + '"]').show();
      //   }, 500);
      // } else {
      //   current.parents('.home-pro-card').find('.ofr-tag').hide();
      // }
    });

    setTimeout(function () {
      history.pushState(null, '', current_url);
    }, 500);
    $(this).parents('.home-pro-card-2').find('img.product-image').attr('src', var_img);
  });


  // pdf variant image
  $('.product__media-toggle').on('click', function () {
    const index = $(this).parent().parent().parent().index();
    setTimeout(() => {
      // $('.modal-body .thumbnail-list li').find('button').attr('aria-current', false)
      $('.modal-body .thumbnail-list li').eq(index).find('button').click();
    }, 200);
  });

  $('.modal-body .thumbnail-list li')
    .find('button')
    .on('click', function () {
      $('.modal-body .thumbnail-list li')
        .find('button')
        .removeAttr('aria-current');
      $(this).attr('aria-current', true);
      setTimeout(() => {
        $('.modal-body .thumbnail-list li')
          .find('button')
          .removeAttr('aria-current');
        $(this).attr('aria-current', true);
      }, 850);
    });
});
// mega menu fix
window.onload = function () {
  setTimeout(function () {
    const elements = document.querySelectorAll(
      '.huk_menu_item_level_2.huk_menu_item_mobile'
    );
    elements.forEach(function (element) {
      element.classList.add('huk_menu_item_active');
    });
  }, 2000);
};


$(document).ready(function () {
  const blogHandles = ['hair', 'ingredient', 'body']; // Add more blog handles as needed

  $('#search-blog').on('input', function () {
    performSearch();
  });

  function performSearch() {
    const query = $('#search-blog').val();

    if (query.length < 3) {
      $('.search-results-blogs').empty();
      return;
    }
    const searchUrl = '/search?type=article&q=' + encodeURIComponent(query); // Adjust the search URL to target only blog posts
    console.log(query + ' : ' + searchUrl);
    $.ajax({
      type: 'GET',
      url: searchUrl,
      success: function (data) {
        const searched_article = $(data).find('.template-search .product-grid').html();
        console.log(data);
        $('.search-results-blogs').show();
        if ($.trim(searched_article) !== '') {
          $('.search-results-blogs').html(searched_article); // Replace the content of the search results div with the response data
        } else {
          $('.search-results-blogs').html('<p class="pb-3">Sorry, something went wrong with the search.</p>'); // Display an error message if the no result found
        }
      },
      error: function () {
        $('.search-results-blogs').html('<p>Sorry, something went wrong with the search.</p>'); // Display an error message if the request fails
      }
    });
  }

  $('body').on('click', '.hm-pro-variant label', function (e) {
    const var_img = $(this).attr('data-variant-img');
    console.log(var_img);
    $(this).parents('.buy-now').find('.buy-img img').attr('src', var_img);
    const current = $(this);
    current.parents('.buy-now').find('.product-form__quantity').removeClass('active');
  });
});

// function to remove discount
// async function removeDiscount() {
//   await fetch('/payments/config', { method: 'GET' })
//     .then((response) => response.json())
//     .then((data) => {
//       const checkout_json_url = '/wallets/checkouts/';
//       const authorization_token = btoa(data.paymentInstruments.accessToken);

//       fetch('/cart.js', {}).then((res) => res.json())
//         .then((cartData) => {
//           const body = {
//             checkout: {
//               country: Shopify.country,
//               discount_code: '', // Empty discount code to remove it
//               line_items: cartData.items,
//               presentment_currency: Shopify.currency.active,
//             },
//           };

//           fetch(checkout_json_url, {
//             headers: {
//               'accept': '*/*',
//               'cache-control': 'no-cache',
//               'authorization': 'Basic ' + authorization_token,
//               'content-type': 'application/json, text/javascript',
//               'pragma': 'no-cache',
//               'sec-fetch-dest': 'empty',
//               'sec-fetch-mode': 'cors',
//               'sec-fetch-site': 'same-origin',
//             },
//             referrerPolicy: 'strict-origin-when-cross-origin',
//             method: 'POST',
//             mode: 'cors',
//             credentials: 'include',
//             body: JSON.stringify(body),
//           })
//             .then((response) => response.json())
//             .then((data) => {
//               if (data.checkout && data.checkout.applied_discounts.length === 0) {
//                 console.log('Discount removed successfully');
//                 // You can update the UI to reflect the removed discount here
//               } else {
//                 console.log('Failed to remove discount');
//               }
//             })
//             .catch((error) => {
//               console.error('Error removing discount:', error);
//             });
//         });
//     });
// }

// product card variant change
function updateVariantChange() {
  const variantSwatches = document.querySelectorAll('.custom_variant__swatches');

  variantSwatches.forEach((swatch) => {
    swatch.addEventListener('click', (e) => {
      console.log("swatch", swatch)
      e.preventDefault();
      handleVariantChangeInProductCard(e);
    });
  });
}

$(document).ready(function () {
  updateVariantChange();
});


const customFacet = document.querySelector(".custom-collec-fecet");
if (customFacet) {
  customFacet.addEventListener('change', () => {
    const productsContainer = document.querySelector('.product-grid');
    if (productsContainer) {
      const observer = new MutationObserver((mutations) => {
        updateVariantChange();
        observer.disconnect();
      });

      observer.observe(productsContainer, {
        childList: true,
        subtree: true
      });
    } else {
      setTimeout(() => {
        updateVariantChange();
      }, 1000);
    }
  });
}

// function handleVariantChangeInProductCard(ev) {
//   const targetEl = ev.target;
//   const productCard = targetEl?.closest('.h-pro-card-cnt');
//   const targetVariantId = targetEl.dataset.variantId;
//   console.log('activeVariant: ', targetVariantId);

//   const quantitySelectors = productCard?.querySelectorAll('.custom-qty-wrapper');
//   // const quantitySelectors = productCard?.querySelectorAll('.product-form__input.product-form__quantity');
//   const addToCartBtn = productCard?.querySelector('.product-form__submit');
//   let isActiveVariantFound = false;
//   quantitySelectors?.forEach((qnty) => {
//     const qntyVariantId = qnty.dataset.qtyVariantId;
//     if (qntyVariantId === targetVariantId) {
//       qnty.classList.add('active');
//       isActiveVariantFound = true;
//       console.log("active class added to variant")
//     } else {
//       qnty.classList.remove('active');
//       console.log("active class removed from variant")
//     }
//   });
//   // Enable/Disable Add to Cart button after checking all selectors
//   if (isActiveVariantFound) {
//     addToCartBtn?.classList.remove('disabled');
//     console.log("active variant found")
//   } else {
//     addToCartBtn?.classList.add('disabled');
//     console.log("active variant not found")
//   }
// }

const activeWrappers = document.querySelectorAll('.custom-qty-wrapper.active');

// Build a SET of active variant IDs
const activeVariantIds = new Set(
  [...activeWrappers].map(el => el.dataset.qtyVariantId)
);

console.log(activeVariantIds);

document.querySelectorAll('.custom-qty-wrapper').forEach(wrapper => {
  const variantId = wrapper.dataset.qtyVariantId;
  const input = wrapper.querySelector('input');
  console.log(input.value)
  if (!input) return;

  if (!activeVariantIds.has(variantId)) {
    if (input.value < 1) {
      wrapper.classList.remove('active');
      console.log('active removed for', variantId);
    }
  }
});


// document.addEventListener("DOMContentLoaded", () => {
//   const firstSwatch = document.querySelector(
//     '.custom_variant__swatches.variant-available'
//   );

//   if (!firstSwatch) return;

//   firstSwatch.classList.add('active');
//   const variantId = firstSwatch.dataset.variantId
//   document.querySelectorAll('.pro-variant-price, .pro-variant-price-svg , product_card__price_container , .text-decoration-line-through , .h-pro-card-sale')
//     .forEach(el => el.classList.remove('active'));

//   document
//     .querySelector(`.pro-variant-price[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');

//   document
//     .querySelector(`.pro-variant-price-svg[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');

//   document
//     .querySelector(`.product_card__price_container[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');

//   document
//     .querySelector(`.text-decoration-line-through[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');

//   document
//     .querySelector(`.h-pro-card-sale[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');
// });

function handleVariantChangeInProductCard(ev) {
  const targetEl = ev.target;

  if (!targetEl.checked) return;

  const productCard = targetEl.closest('.h-pro-card-cnt');
  if (!productCard) return;

  const targetVariantId = targetEl.dataset.variantId;
  console.log('activeVariant:', targetVariantId);

  productCard
    .querySelectorAll(
      '.pro-variant-price, .pro-variant-price-svg, .product_card__price_container, .text-decoration-line-through, .h-pro-card-sale'
    )
    .forEach(el => el.classList.remove('active'));

  productCard
    .querySelector(`.pro-variant-price[data-variant-id="${targetVariantId}"]`)
    ?.classList.add('active');

  productCard
    .querySelector(`.pro-variant-price-svg[data-variant-id="${targetVariantId}"]`)
    ?.classList.add('active');

  productCard
    .querySelector(`.product_card__price_container[data-variant-id="${targetVariantId}"]`)
    ?.classList.add('active');

  productCard
    .querySelector(`.text-decoration-line-through[data-variant-id="${targetVariantId}"]`)
    ?.classList.add('active');

  productCard
    .querySelector(`.h-pro-card-sale[data-variant-id="${targetVariantId}"]`)
    ?.classList.add('active');

  const quantitySelectors = productCard.querySelectorAll('.custom-qty-wrapper , .product-form__quantity');
  const addToCartBtn = productCard.querySelector('.product-form__submit');

  let isActiveVariantFound = false;

  quantitySelectors.forEach(qnty => {
    const inputQuantity = qnty.querySelector("input");
    console.log("qnty.dataset.qtyVariantId custom", qnty.dataset.qtyVariantId);
    console.log("targetVariantId custom", targetVariantId)
    if (qnty.dataset.qtyVariantId === targetVariantId) {
      if (inputQuantity.value > 0) {
        console.log("inputQuantity", inputQuantity.value);
        qnty.classList.add('active');
        console.log("active class added new")
      }
      // else{
      //   inputQuantity.value = 1;
      //   qnty.classList.remove('active');
      // }
      isActiveVariantFound = true;
    } else {
      qnty.classList.remove('active');
    }
  });

  addToCartBtn?.classList.toggle('disabled', !isActiveVariantFound);
}

document.addEventListener('change', e => {
  if (!e.target.matches('input[type="radio"]')) return;

  if (!e.target.checked) return;

  const label = document.querySelector(`label[for="${e.target.id}"]`);
  if (!label?.classList.contains('custom_variant__swatches')) return;

  label
    .closest('.h-pro-card-cnt')
    ?.querySelectorAll('.custom_variant__swatches')
    .forEach(s => s.classList.remove('active'));

  label.classList.add('active');

  handleVariantChangeInProductCard(e);
});

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.h-pro-card-cnt').forEach(productCard => {

    const checkedRadio = productCard.querySelector(
      'input[type="radio"]:checked'
    );

    if (!checkedRadio) return;

    handleVariantChangeInProductCard({
      target: checkedRadio
    });

  });

});

async function fetchCheckoutData() {
  try {
    const response = await fetch('/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const cart = await response.json();
    if (cart.cart_level_discount_applications?.length > 0) {
      const discountTitle = cart.cart_level_discount_applications[0]?.title;
      if (discountTitle) {
        applyDiscount(discountTitle);
        const couponText = document.querySelector('.cart-coupon-button text');
        const couponInput = document.querySelector("#discount-code-input");

        if (couponText) couponText.innerHTML = `${discountTitle} APPLIED`;
        if (couponInput) couponInput.value = discountTitle;
        const offerElement = document.querySelector('.offer-by-total');
        // if (offerElement) {
        //     offerElement.style.display = 'none';  

        //     if (!document.querySelector('.offer-message')) {
        //         offerElement.insertAdjacentHTML('afterend', '<div class="offer-message">B2G1 cannot be applied with your existing discount</div>');
        //     }
        // }
      }
    } else {
      const couponText = document.querySelector('.cart-coupon-button text');
      if (couponText) couponText.innerHTML = `APPLY COUPONS`
      console.log('No discount title found');
      localStorage.removeItem('discountCode');
      await deleteCookie('discount_code');
      // await removeDiscount();
    }
  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}

fetchCheckoutData()



$('.product-media-carousel').owlCarousel({
  items: 1,
  loop: false,
  nav: true,
  dots: true,
  margin: 10,
  smartSpeed: 600,
  center: true,
  autoWidth: false,
  navText: [
    `<span class="owl-prev" style="transform: rotate(180deg)"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="36" viewBox="0 0 31 36" fill="none">
<path d="M8.11106 32.0395L22.2063 17.9443L8.11106 3.84906L6.50055 5.45957L18.9852 17.9443L6.50055 30.4289L8.11106 32.0395Z" fill="#1C1B1F"/>
</svg></span>`,
    `<span class="owl-next"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="36" viewBox="0 0 31 36" fill="none">
<path d="M8.11106 32.0395L22.2063 17.9443L8.11106 3.84906L6.50055 5.45957L18.9852 17.9443L6.50055 30.4289L8.11106 32.0395Z" fill="#1C1B1F"/>
</svg></span>`
  ]
});

// //Price change on variant change
// function activateVariantPrice(variantId) {
//   document.querySelectorAll('.pro-variant-price, .pro-variant-price-svg , product_card__price_container , .text-decoration-line-through , .h-pro-card-sale')
//     .forEach(el => el.classList.remove('active'));

//   document
//     .querySelector(`.pro-variant-price[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');

//   document
//     .querySelector(`.pro-variant-price-svg[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');

//   document
//     .querySelector(`.product_card__price_container[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');

//   document
//     .querySelector(`.text-decoration-line-through[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');

//   document
//     .querySelector(`.h-pro-card-sale[data-variant-id="${variantId}"]`)
//     ?.classList.add('active');
// }

// document.addEventListener("DOMContentLoaded", () => {
//   const firstSwatch = document.querySelector(
//     '.custom_variant__swatches.variant-available'
//   );

//   if (!firstSwatch) return;

//   firstSwatch.classList.add('active');
//   activateVariantPrice(firstSwatch.dataset.variantId);
// });

// document.addEventListener("change", e => {
//   if (!e.target.matches('input[type="radio"]')) return;

//   const label = document.querySelector(`label[for="${e.target.id}"]`);
//   if (!label?.classList.contains('custom_variant__swatches')) return;

//   document.querySelectorAll('.custom_variant__swatches')
//     .forEach(s => s.classList.remove('active'));

//   label.classList.add('active');
//   activateVariantPrice(label.dataset.variantId);
// });

